import { StickyNavigation } from "@/components/StickyNavigation";
import { Footer } from "@/components/Footer";
import { HeroSection } from "@/components/landing/HeroSection";
import { MissionSection } from "@/components/landing/MissionSection";
import { InspirationalAISection } from "@/components/landing/InspirationalAISection";
import { SelfDirectedAISection } from "@/components/landing/SelfDirectedAISection";
import { SystemStatusSection } from "@/components/landing/SystemStatusSection";
import { AboutSection } from "@/components/landing/AboutSection";

const LandingPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center">
      <StickyNavigation />
      <main className="w-full flex-1 pt-20">
        <HeroSection />
        <MissionSection />
        <InspirationalAISection />
        <SelfDirectedAISection />
        <SystemStatusSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
